<div class="chart-container">
  <div *ngIf="isLoading" class="loading-spinner">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <app-line-chart
    *ngIf="!isLoading"
    [chartData]="trendingChartData"
    [xAxisType]="'datetime'"
    [xAxisTickInterval]="xAxisTickInterval"
    [yAxisLabelFormat]="yAxisLabelFormat"
    [tooltipOptions]="tooltipOptions"
    [showLegend]="true"
    [useStockChart]="false"
  ></app-line-chart>
</div>
